
import styled from 'styled-components'

import theme, {media} from '@/src/config/theme'

import {Link} from '@/src/shared/ui/link'

export const Wrapper = styled.div``

export const CatalogSectionList = styled.div`
  display: flex;
  flex-wrap: wrap;
  
  gap: 10px;
  padding: 10px;
  
  @media ${media.md} {
    gap: 36px;
  }
`
export const CatalogSectionItem = styled.div``

export const ItemWrapper = styled.div`
  border: solid 1px ${theme.colors.gray6};
  
  border-radius: 5px;
  
  width: 100%;
  
  max-width: 100%;
  
  transition: 0.5s ease transform;
  
  
  @media ${media.md} {
    max-width: calc((100% / 3) - 36px + (36px / 3));
  }

  @media ${media.lg} {
    max-width: calc((100% / 4) - 36px + (36px / 4));

    &:hover {
      transform: scale(1.05);
      z-index: 10;
      border-bottom: unset;
    }
  }
`

export const ItemHead = styled(Link)`
  min-height: 40px;
  margin-top: 13px;
  color: ${theme.colors.dark5};
  word-break: break-word;
  text-align: center;
  
  &, & span {
    font-size: 1.25rem;
    font-weight: 450;
    color: ${theme.colors.dark};
  }
`

export const SubItemHead = styled(Link)`
  color: ${theme.colors.gray8};
  background: #0000000d;
  border-radius: 5px;
  
  word-break: break-word;
  text-align: center;

  padding-block-end: 2px;
  padding-block-start: 2px;
  padding-bottom: 2px;
  padding-inline-end: 8px;
  padding-inline-start: 8px;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 2px;
  
  &, & span {
    font-size: 1.15rem;
    color: ${theme.colors.gray8};
  }
`

export const Item = styled.div`
  padding: 20px;
  
  display: flex;
  flex-direction: column;
  align-items: center;
  
  width: 100%;
`

export const Image = styled.div`
    & img {
      //height: 133px;
      width: auto;
    }
`

export const ItemChild = styled.div`
  
`

export const ChildrenContainer = styled.div`
    position: relative;
`

export const Children = styled.div<{$open: boolean}>`
  
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;

  gap: 4px;

  display: flex;

  flex-wrap: wrap;

  border: unset;
    
  @media ${media.lg} {
    display: none;
    position: absolute;
    background: white;
    
    top: -10px;
    box-sizing: border-box;
    width: calc(100% + 2px);
    left: -1px;

    border-left: solid 1px ${theme.colors.gray6};
    border-right: solid 1px ${theme.colors.gray6};
    border-bottom: solid 1px ${theme.colors.gray6};

    border-radius: 5px;

    border-start-start-radius: unset;
    border-start-end-radius: unset;
  }
  
  ${ItemWrapper}:hover & {
    display: flex;
  }
`
